export default __webpack_public_path__ + "static/media/Path1221.64c113fb.png";